import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sessionsNew, products } from "actions";
import isMobile from 'common/helpers/isMobile';

const SessionsNewFilterContainer = ({ children, type }) => {
  const [filterState, setFilterState] = useState({});
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [isFilterTouched, setFilterTouched] = useState(false);

  const dispatch = useDispatch();

  // @todo: to refactor actions
  const filter =
    type === "calendar"
      ? useSelector((state) => state.sessionsNew.filter)
      : useSelector((state) => state.products.filter);
  const filterCurrent =
    type === "calendar"
      ? useSelector((state) => state.sessionsNew.current_filters)
      : useSelector((state) => state.products.current_filters);

  useEffect(() => {
    if (type === "calendar") {
      dispatch(sessionsNew.getFilters(true));
    } else {
      dispatch(products.getFilters(true));
    }
  }, []);

  useEffect(() => {
    if (isFilterOpen) {
      document.documentElement.classList.add('locked-mobile')
    } else {
      document.documentElement.classList.remove('locked-mobile')
    }
  }, [isFilterOpen])

  const selectChange = useCallback(
    (name, value, label, options) => {
      options.forEach(option => {
        window.dataLayer && window.dataLayer.push({
          'event': 'filter_click',
          'filter_name': label,
          'subfilter_name': option
        });
      });

      if (isMobile) {
        setFilterState({
          ...filterState,
          [name]: value,
        });
      } else {
        if (type === "calendar") {
          dispatch(sessionsNew.changeValue(name, value));
        } else {
          dispatch(products.changeValue(name, value));
        }
      }
  }, [dispatch, setFilterState, isMobile, filterState]);

  const dateChange = useCallback(
    (start, end) => {
      window.dataLayer && window.dataLayer.push({
        'event': 'filter_click',
        'filter_name': 'Choose dates',
        'subfilter_name': end ? `${start} - ${end}` : start
      });

      if (isMobile) {
        setFilterState({
          ...filterState,
          start_date: start,
          end_date: end,
        });
      } else {
        if (type === "calendar") {
          dispatch(sessionsNew.changeDate(start, end));
        } else {
          dispatch(products.changeDate(start, end));
        }
      }
    }, [dispatch, setFilterState, isMobile, filterState]);

  const toggleChange = useCallback(
    (name, value, label) => {
      window.dataLayer && window.dataLayer.push({
        'event': 'filter_click',
        'filter_name': label,
        'subfilter_name': value ? 'On' : 'Off'
      });
      if (isMobile) {
        setFilterState({
          ...filterState,
          [name]: value,
        });
      } else {
        if (type === "calendar") {
          dispatch(sessionsNew.changeValue(name, value));
        } else {
          dispatch(products.changeValue(name, value));
        }
      }
    }, [dispatch, setFilterState, isMobile, filterState]);

  const parentCategoryChange = useCallback(
    (value, label) => {
      if (value !== filterCurrent.parent_category) {
        window.dataLayer && window.dataLayer.push({
          'event': 'navigation',
          'ctaName': label
        });
        if (type === "calendar") {
          dispatch(sessionsNew.changeParentCategory(value));
        } else {
          dispatch(products.changeParentCategory(value));
        }
        if (isMobile) {
          setFilterOpen(false);
        }
      }
    }, [dispatch, setFilterOpen, isMobile, filterCurrent]);

  const resetFilters = useCallback(
    () => {
      if (type === "calendar") {
        dispatch(sessionsNew.clearFilters());
      } else {
        dispatch(products.clearFilters());
      }
      setFilterState({});
      setFilterTouched(!isFilterTouched);
    }, [dispatch, setFilterState, setFilterTouched, isFilterTouched]);

  const toggleFilter = useCallback(
    () => {
      setFilterOpen(!isFilterOpen);
      setFilterTouched(!isFilterTouched);
    }, [setFilterState, setFilterTouched, isFilterOpen, isFilterTouched]);

  const submit = () => {
    if (type === "calendar") {
      dispatch(sessionsNew.submitAll(filterState));
    } else {
      dispatch(products.submitAll(filterState));
    }

    setFilterState({});
    setFilterOpen(!isFilterOpen);
    setFilterTouched(!isFilterTouched);
  };

  const filtersCount = () => {
    let filtersCount = 0;
    for (const [key, value] of Object.entries(filterCurrent)) {
      if (
        !(value == null || (Array.isArray(value) && !value.length)) &&
        key !== "parent_category"
      ) {


        if (key != 'start_date' && key != 'end_date') {
          filtersCount += value.length;
        } else {
          filtersCount += 1;
        }
      }
    }
    return filtersCount;
  };

  return children({
    filter,
    filterCurrent,
    parentCategoryChange,
    toggleFilter,
    dateChange,
    selectChange,
    toggleChange,
    isFilterOpen,
    isFilterTouched,
    resetFilters,
    filtersCount,
    submit
  });
};

export default SessionsNewFilterContainer;
